import React from "react";
import cx from "clsx";
import moment from "moment";
import { Timer } from "../../../../pages/Patients/Documents/All/shared/Table/shared/Actions/Timer";
import { isMedicalHistoryFile } from "../../../../pages/Patients/Documents/All/utilities";
import VIEW_ICON from "../../../Clients/Documents/icons/view.svg";
import { checkIfPermissionAllowed } from "../../../../Utils";
import classes from "../scss/expirationActionButtons.module.scss";

const ExpirationActionButtons = ({
  document,
  reportSysName,
  setSelectedDocument,
  refetchData,
}) => {
  const canView = checkIfPermissionAllowed("view-documents");
  const canUpdateExpiration =
    checkIfPermissionAllowed("add-update-documents") &&
    !document.is_lock &&
    (!isMedicalHistoryFile(document.name) ||
      checkIfPermissionAllowed("manage-medical-history"));
  const isDocumentsExpiration = reportSysName === "documents-expiration";
  const isLocked = !isDocumentsExpiration && Boolean(document.is_lock);

  if (!canView) {
    return null;
  }

  return (
    <div className="flex justify-center gap-8">
      <button
        className={cx("header-unselect-btn", "modal-link", classes.viewIcon)}
        disabled={isLocked}
        onClick={() => {
          if (isDocumentsExpiration) {
            window.open(document.file_url, "_blank", "noopener,noreferrer");
          } else if (!isLocked) {
            setSelectedDocument(document);
          }
        }}
      >
        <img
          src={VIEW_ICON}
          className={cx("min-w-16", {
            "cursor-pointer": !isLocked,
            "cursor-not-allowed": isLocked,
          })}
          title="View"
          width={16}
          height={16}
          alt=""
        />
      </button>
      {isDocumentsExpiration && canUpdateExpiration && (
        <Timer
          documentId={Number(document.id)}
          patientId={Number(document.patient_id || document.patient?.id)}
          patientName={document.patient?.full_name}
          name={document.name}
          date={document.created_at}
          type={document.doc_type}
          typeLabel={document.doc_type_label || document.doc_type}
          expirationDate={document.expiration_date}
          expirationDateEditor={document.expiration_date_editor}
          lastEditedExpirationDate={document.last_edited_expiration_date}
          expireSoon={
            moment(document.expiration_date).diff(moment(), "days") <= 30 &&
            !document.acknowledged_at
          }
          onSuccess={refetchData}
        />
      )}
    </div>
  );
};

export default ExpirationActionButtons;
